import { render, staticRenderFns } from "./RootModalComponent.vue?vue&type=template&id=3ba025a6&"
import script from "./RootModalComponent.vue?vue&type=script&lang=js&"
export * from "./RootModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./RootModalComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports